<template lang="pug">
Common.signup-verification-set-password(v-else :title="title" :errors="errors" :calculatedRoute="passwordRoute")
  h1(slot='header') {{ title }}

  template(#main="{ calculatedRoute }")
    SetPassword(
      :showAgreeTerms="true"
      :route="calculatedRoute"
      :new-request="{ url: $site.Routes.Signup.GetEmailVerification, message: 'Request a new account verification email' }"
      set-password-message="Thank you for verifying your email address, we now need you to set a password for your account."
      @errors="onErrors")
</template>

<script>
import { Common, SetPassword } from "AccountPages/components";

export default {
  name: "SignupVerificationSetPassword",
  components: {
    Common,
    SetPassword,
  },
  data() {
    const route = this.$app.api.Routes.Accounts.Signup.Local.GetVerify(this.$route.params.verificationKey);
    const query = this.$route.fullPath.split("?")[1];
    const passwordRoute = route + (query ? "?" + query : "");

    return {
      passwordRoute,
      errors: [],
      title: "Set your password",
    };
  },
  methods: {
    onErrors(errors) {
      this.errors = errors;
    },
  },
};
</script>
